import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import Layout from "../../../components/layouts/Layout";
import { useTranslation } from "react-i18next";

const mockTicket = {
  id: 1,
  title: "Issue with order #123",
  status: "accepted",
  messages: [
    { id: 1, sender: "store", text: "Hello, I have an issue.", createdAt: "2025-10-18T10:00:00" },
    { id: 2, sender: "admin", text: "Sure, can you describe it?", createdAt: "2025-10-18T10:02:00" },
  ],
};

interface MessageFormData {
  text: string;
}

export default function TicketDetailPage() {
  const [messages, setMessages] = useState(mockTicket.messages);
  const {t} = useTranslation();
  const disabled = ["rejected", "closed"].includes(mockTicket.status);

  const { register, handleSubmit, reset } = useForm<MessageFormData>({
    defaultValues: { text: "" },
  });

  const onSubmit: SubmitHandler<MessageFormData> = (data) => {
    const newMessage = {
      id: messages.length + 1,
      sender: "store",
      text: data.text.trim(),
      createdAt: new Date().toISOString(),
    };
    setMessages([...messages, newMessage]);
    reset(); // clears the input
  };

  return (
    <Layout title="" headline="">
      <div className="flex flex-col h-full p-4">
        {/* Ticket Header */}
        <div className="border-b pb-2 mb-3">
          <h1 className="text-lg font-semibold">{mockTicket.title}</h1>
          <span className="text-sm text-muted capitalize">{t("status")}: {mockTicket.status}</span>
        </div>

        {/* Messages */}
        <div className="flex-1 overflow-y-auto space-y-2 mb-3">
          {messages.map((msg) => (
            <div
              key={msg.id}
              className={`flex ${msg.sender === "store" ? "justify-end" : "justify-start"}`}
            >
              <div
                className={`p-2 rounded-lg max-w-[70%] ${
                  msg.sender === "store" ? "bg-primary text-white" : "bg-gray-200"
                }`}
              >
                <p>{msg.text}</p>
                <span className="text-xs text-gray-700 block text-right">
                  {new Date(msg.createdAt).toLocaleTimeString()}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Message Input */}
        <form onSubmit={handleSubmit(onSubmit)} className="flex gap-2">
          <input
            type="text"
            {...register("text", { required: true })}
            placeholder={disabled ? t('ticket_closed') : t("type_message")}
            disabled={disabled}
            className="flex-1 border rounded-md p-2 outline-none"
          />
          <button
            type="submit"
            disabled={disabled}
            className="bg-primary text-white px-4 py-2 rounded-md capitalize"
          >
            {t('send')}
          </button>
        </form>
      </div>
    </Layout>
  );
}
